import { create } from "zustand";

// This is in another file purely for hot reloading purposes

interface QueryPopoverStore {
  data: null | {
    anchorEl: HTMLElement;
    qid: string;
  };
  reset(): void;
  showPopover(target: HTMLElement, qid: string): void;
}

export const useQueryPopoverStore = create<QueryPopoverStore>((set) => ({
  data: null,
  reset: () => set({ data: null }),
  showPopover: (anchorEl: HTMLElement, qid: string) =>
    set({ data: { anchorEl, qid } }),
}));
